import React from 'react';

const FAQContent = () => {
  return (
    <div className="legal-content">
      <h2>🧠 Frequently Asked Questions (FAQ)</h2>

      <h3>🟢 General Use & Functionality</h3>

      <h4>1. What is Naoko?</h4>
      <p>
        Naoko is a personal AI assistant that helps users apply for government documents and social welfare services across India. It simplifies the process by collecting documents, extracting information, and submitting applications — all through a simple chat interface.
      </p>

      <h4>2. How does Naoko work?</h4>
      <p>
        Naoko guides users step-by-step using natural language. It collects required documents, extracts data, and applies for the selected service on your behalf. Naoko also tracks the application status and helps you reapply if needed.
      </p>

      <h4>3. Do I need to visit a government office?</h4>
      <p>
        No. Naoko handles everything online for supported services — no need for physical visits.
      </p>

      <h4>4. How do I get started?</h4>
      <p>
        Sign up using your name, email or phone number, and password. Once logged in, you can chat with Naoko or use the web interface to book services and upload documents.
      </p>

      <h4>5. Is OTP required to log in?</h4>
      <p>
        No. Naoko uses a simple login system with email or phone and a password — no OTP needed.
      </p>

      <h4>6. What documents are required?</h4>
      <p>
        Each service lists its required documents under “View Details.” Common ones include Aadhaar card, income certificate, tribe certificate, and address proof. Naoko guides you based on the selected service.
      </p>

      <h4>7. Can I use Naoko anywhere in India?</h4>
      <p>
        Yes — for PAN card and Aadhaar services. State-specific welfare services are currently available only in <strong>Manipur</strong>, with more states coming soon.
      </p>

      <h4>8. Does Naoko support different languages?</h4>
      <p>
        Absolutely! Naoko supports 400+ Indian and international languages. Just type or speak naturally — Naoko understands.
      </p>

      <h3>💸 Payments & Pricing</h3>

      <h4>9. Is Naoko free to use?</h4>
      <p>
        Many social welfare services are completely free. Some services include a small processing fee.
      </p>

      <h4>10. What are the charges for paid services?</h4>
      <ul>
        <li>Social welfare services: <strong>Free</strong></li>
        <li>PAN card application: <strong>₹150</strong></li>
        <li>Certificate/document services: <strong>₹30</strong></li>
      </ul>
      <p>Naoko always shows the cost before you confirm a booking.</p>

      <h4>11. How do I pay for a service?</h4>
      <p>
        Payments are made securely through a trusted third-party gateway. Naoko guides you through each step.
      </p>

      <h4>12. Are payments secure?</h4>
      <p>
        Yes. All payments are processed securely and encrypted through a trusted provider.
      </p>

      <h3>📄 Applications & Documents</h3>

      <h4>13. How are my documents handled?</h4>
      <p>
        Documents are securely uploaded during chat or through the web interface. They are used only to fill and submit your applications. For most services, they’re deleted after submission is confirmed.
      </p>

      <h4>14. Can I track my application status?</h4>
      <p>
        Yes. You can view and track the status anytime from your dashboard.
      </p>

      <h4>15. How long does it take to process my application?</h4>
      <p>
        It depends on the service and the government body involved. Naoko keeps you updated and helps if issues arise.
      </p>

      <h4>16. Can I download my application later?</h4>
      <p>
        Yes. You can download your filled application or confirmation anytime from your account.
      </p>

      <h4>17. Is my data saved for future use?</h4>
      <p>
        Yes. Previously uploaded information can be reused for faster future bookings. Local storage will soon allow you to keep documents without re-uploading.
      </p>

      <p style={{ marginTop: '1rem' }}>
        Still have questions? Reach out through the contact options in the footer.
      </p>
    </div>
  );
};

export default FAQContent;
